import React from 'react';
import PropTypes from 'prop-types';
import {LocaleProvider, Form, Select, message, Input} from 'antd';
import ui from '../../lang/ui.json';
import s from './NewUser.css';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import {Link} from 'react-router-dom';
import history from '../../history';
import {isValidPhoneNumber} from "../../phoneNumberUtils";

class NewUser extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        locale: PropTypes.objectOf(PropTypes.string).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            number: '',
            name: '',
            data: [],
            multiple: [],
            textValidation: true,
            numberValidation: true,
            config: require('Config'),
        };
        this.numberChange = this.numberChange.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.checkValidation = this.checkValidation.bind(this);
    }

    checkValidation() {
        let textValidation = this.state.name != null && this.state.name != "";
        this.setState({textValidation: textValidation});

        let numberValidation = this.state.number != null && this.state.number != "" && isValidPhoneNumber(this.state.number);
        this.setState({numberValidation: numberValidation});

        return numberValidation && textValidation;
    }

    userAdd = (id) => {
        fetch(this.state.config.serverUrl + `contacts/user/${id}`,
            {
                headers: new Headers({
                    'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                    'Content-Type': 'application/json',
                    'username': `${sessionStorage.getItem('username')}`
                }),
                method: 'PUT',
                body: JSON.stringify({name: id}),
            },
        )
            .then((response) => {
                if (response.status === 204) {
                    this.successMessage();
                } else {
                    this.errorMessage(response.statusText);
                }
            });
    };

    numberChange(event) {
        this.setState({number: event.target.value});
    }

    nameChange(event) {
        this.setState({name: event.target.value});
    }

    successMessage = () => {
        message.success(this.props.locale.messageSuccess, 2);
    };

    errorMessage = (error) => {
        message.error(`${this.props.locale.messageError} ${error}`, 5);
    };

    addUser = (e) => {
        e.preventDefault();
        if (this.checkValidation()) {
            fetch(this.state.config.serverUrl + `contacts/add`,
                {
                    method: 'PUT',
                    body: JSON.stringify({contacts: [{msisdn: this.state.number, name: this.state.name}]}),
                    headers: new Headers({
                        'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                        'content-type': 'application/json; charset=UTF-8',
                        'username': `${sessionStorage.getItem('username')}`
                    })
                },
            )
                .then((response) => {
                    if (response.status === 204) {
                        this.successMessage();
                        history.push('/contacts');
                    } else {
                        this.errorMessage(response.statusText);
                    }
                });
        }
    };

    render() {
        const Option = Select.Option;
        const FormItem = Form.Item;
        return (
            <LocaleProvider locale={ui}>
                <div className={s.root}>
                    <Breadcrumbs title={this.props.locale.breadcrumbs} link="/contacts"/>
                    <h1>{this.props.locale.title}</h1>
                    <Form onSubmit={this.addUser} className={s.form}>
                        <FormItem
                            className={s.input_wrapper}
                            validateStatus={this.state.numberValidation ? 'success' : 'error'}
                            help={this.state.numberValidation ? '' : this.props.locale.missingNumberMessage}
                        >
                            <span className={s.input_name}>{this.props.locale.numberLabel}</span>
                            <Input className={s.text_input}
                                   value={this.state.number}
                                   placeholder={this.props.locale.numberPlaceholder}
                                   onChange={this.numberChange}/>
                        </FormItem>
                        <FormItem
                            validateStatus={this.state.textValidation ? 'success' : 'error'}
                            help={this.state.textValidation ? '' : this.props.locale.missingNameMessage}>
                            <span className={s.input_name}>{this.props.locale.nameLabel}</span>
                            <Input className={s.text_input} name="name" value={this.state.name}
                                   placeholder={this.props.locale.namePlaceholder} onChange={this.nameChange}
                                   maxLength={50}/>
                        </FormItem>
                        <div className={s.button_wrapper}>
                            <Link className={s.btn_warning} to="/contacts">{this.props.locale.buttonCancel}</Link>
                            <button className={s.btn_primary}>{this.props.locale.buttonAdd}</button>
                        </div>
                    </Form>
                </div>
            </LocaleProvider>
        );
    }
}

export default (NewUser);




// WEBPACK FOOTER //
// ./src/routes/contacts/NewUser.js